<template>
    <div class="item">
        <div class="nav">
          <div class="logo"><img src="/assets/images/logo-navbar.svg"></div>
            <div class="button-home" @click="goSpots"><img :src="'/assets/buttons/button-home.svg'"></div>
            <div class="button-close" @click="goItems"><img :src="'/assets/buttons/button-close.svg'"></div>
        </div>
        <div class="header">
<!--          <div class="kiosk-title">{{kioskTitle}}</div>-->
<!--          <div class="group-title">{{ decodeURI(themeTitle) }}</div>-->
            <div class="object-nr">{{ objectData.object_number }}</div>
            <div class="object-title">{{ decodeURI(objectData.title) }}</div>
        </div>
        <div class="main">
            <div class="media">
                <div class="reproduction">
                    <!-- <img class="reproduction-image" :src="objectData.image" alt="image" @click="showMedia('still', objectData.object_number)"> -->
                    <img class="reproduction-image" :src="objectData.image" alt="image">
                    <!-- <div class="reproduction-credit" v-if="objectData.image_creator !== ''">{{ objectData.image_creator }}</div> -->
                </div>
                <div class="container-media-sub">
                  <div class="container-related">
                    <div class="button-related" v-bind:key="related.id" v-for="related in relatedData" >
                      <img class="image-related" :src="related.image" alt="image" @click="showMedia(related.type, spotId, itemId, related.id)">
                    </div>
                  </div>
                  <div v-if="objectData.audio !== ''" class="container-audio">
                    <AudioPlayer v-bind:file="objectData.audio" />
                  </div>
                </div>
            </div>
            <div class="description" v-html="objectData.description">
<!--                {{ decodeURI(objectData.description) }}-->
<!--                {{ objectData.description }}-->
            </div>
        </div>
        <div class="fields" v-bind:style="{ background: kioskBackground }">
            <hr>
            <div class="object-date" v-if="objectData.date !== ''">
                <div class="title-date" v-if="langId === 'nl'">Datering</div>
                <div class="title-date" v-if="langId === 'en'">Date</div>
                <div class="title-date" v-if="langId === 'de'">Datierung</div>
                <div class="text-date">{{ objectData.date }}</div>
            </div>
            <div class="object-makers" v-if="makerData.length !== 0">
                <div class="title-makers" v-if="langId === 'nl'">Vervaardiger(s)</div>
                <div class="title-makers" v-if="langId === 'de'">Hersteller</div>
                <div class="title-makers" v-if="langId === 'en'">Makers</div>
                <div class="item-makers" v-bind:key="maker" v-for="maker in makerData">
                    {{ maker }}
                </div>
            </div>
            <div class="object-materials" v-if="materialData.length !== 0">
                <div class="title-materials" v-if="langId === 'en'">Materials</div>
                <div class="title-materials" v-if="langId === 'nl' || langId === 'de'">Materialen</div>
                <div class="item-materials" v-bind:key="material" v-for="material in materialData">
                    {{ material }}
                </div>
            </div>
          <div class="object-dimensions" v-if="dimData.length !== 0">
            <div class="title-dimensions" v-if="langId === 'en'">Dimensions</div>
            <div class="title-dimensions" v-if="langId === 'nl' || langId === 'de'">Afmetingen</div>
            <div class="item-dimensions" v-bind:key="dimension" v-for="dimension in dimData">
              {{ dimension }}
            </div>
          </div>
            <div class="object-context" v-if="objectData.context !== ''">
                <div class="title-context" v-if="langId === 'en'">Origin</div>
                <div class="title-context" v-if="langId === 'nl'">Herkomst</div>
                <div class="title-context" v-if="langId === 'de'">Herkunft</div>
                <div class="text-context">{{ objectData.context }}</div>
            </div>
            <div class="object-creditline">{{ objectData.credit_line }}</div>
        </div>
    </div>
</template>

<script>
import config from '@/config/config.json';
import router from '@/router';
import axios from 'axios';
import AudioPlayer from '@/components/AudioPlayer';

export default {
    name: 'Item',
    props: ['spotId', 'langId', 'itemId'],
    components: {
        AudioPlayer
    },
    data() {
        return {
            configData: config,
            kioskTitle: '',
            themeTitle: '',
            oneTheme: false,
            kioskCode: '',
            kioskBackground: '',
            relatedData: [],
            makerData: [],
            materialData: [],
            dimData: [],
            objectData: {
                "object_number": '',
                "title": '',
                "description": '',
                "image": '/assets/spinners/spinner-600-transparant.gif',
                "image_creator": '',
                "date": '',
                "credit_line": '',
                "context": '',
                "audio": ''
            }
        }
    },
    methods: {
        goLanguage() {
            router.push('/');
        },
        goSpots() {
            router.push('/spots/' + this.langId);
        },
        goItems() {
            router.push('/items/' + this.spotId + '/' + this.langId);
        },
        showMedia(typeIn, spotIn, objectIn, mediaIn) {
            router.push('/' + typeIn + '/' + spotIn + '/' + objectIn + '/' + mediaIn + '/' + this.langId);
        }

    },
    created() {
        const axiosQuery = this.configData.api + 'items/' + this.itemId + '?@key_identity=' + this.configData.key_identity + '&@key_credential=' + this.configData.key_credential;
        axios.get(axiosQuery)
        .then((res) => {
            // object_nr
            if(res.data["dcterms:identifier"]) {
                this.objectData.object_number = res.data["dcterms:identifier"][0]["@value"];
            }
            // titel
            res.data["dcterms:title"].forEach((titleFound) => {
                if(titleFound["@language"] === this.langId) {
                    this.objectData.title = titleFound["@value"];
                }
            });
            // omschrijving
            if(res.data["dcterms:description"]) {
                res.data["dcterms:description"].forEach((descriptionFound) => {
                    if(descriptionFound["@language"] === this.langId) {
                        this.objectData.description = descriptionFound["@value"];
                    }
                });
            }
            // Reproduction - plaatje bij details
            if(res.data.thumbnail_display_urls && res.data.thumbnail_display_urls.large !== null) {
                if(res.data.thumbnail_display_urls.large.slice(-3) === 'jpg' || res.data.thumbnail_display_urls.large.slice(-3) === 'png') {
                    this.objectData.image = res.data.thumbnail_display_urls.large;
                } else {
                    this.objectData.image = '/assets/dummies/dummy_thumb.jpg';
                }
            } else {
                this.objectData.image = '/assets/dummies/dummy_thumb.jpg';
            }

            // afmetingen
            if(res.data["dcterms:format"]) {
                res.data["dcterms:format"].forEach((dimFound) => {
                    if(dimFound["@language"] === this.langId) {
                        this.dimData.push(dimFound["@value"]);
                    }
                });
            }

            // makers
            if(res.data["dcterms:creator"]) {
                res.data["dcterms:creator"].forEach((creatorFound) => {
                    if(creatorFound["@language"] === this.langId) {
                        this.makerData.push(creatorFound["@value"]);
                    }
                });
            }

            // productie datum
            if(res.data["dcterms:date"]) {
                this.objectData.date = res.data["dcterms:date"][0]["@value"];
            }

            // materialen
            if(res.data["dcterms:medium"]) {
                res.data["dcterms:medium"].forEach((materialFound) => {
                    if(materialFound["@language"] === this.langId) {
                        this.materialData.push(materialFound["@value"]);
                    }
                });
            }

            // Context
            // this.objectData.context = res.data.context;

            // sponsors, etc
            if(res.data["dcterms:provenance"]) {
                res.data["dcterms:provenance"].forEach((creditFound) => {
                    if(creditFound["@language"] === this.langId) {
                        this.objectData.credit_line = creditFound["@value"];
                    }
                })
            }

            // related media
            let relatedMediaQuery = this.configData.api + 'media?item_id=' + this.itemId + '&@key_identity=' + this.configData.key_identity + '&@key_credential=' + this.configData.key_credential;
            axios.get(relatedMediaQuery)
            .then((resMedia) => {
                resMedia.data.forEach((mediaFound) => {
                    // console.log('media-item found: ' + JSON.stringify(mediaFound));
                    if(mediaFound["o:media_type"] && mediaFound["o:media_type"].split('/')[0] === 'audio') {
                        if(mediaFound["dcterms:title"]) {
                            mediaFound["dcterms:title"].forEach((audioTitle) => {
                                if(audioTitle["@language"] && audioTitle["@language"] === this.langId) {
                                    // console.log('audio taal: ' + this.langId);
                                    this.objectData.audio = mediaFound["o:original_url"];
                                    // console.log('audio url: ' + mediaFound["o:original_url"]);
                                }
                            });
                        }
                    }
                    if(mediaFound["o:media_type"] && mediaFound["o:media_type"].split('/')[0] === 'image') {
                        // main image not shown in array of related media
                        if(this.objectData.image === mediaFound.thumbnail_display_urls.large) {
                            // console.log('plaatje main')
                        } else {
                            // console.log('plaatje (thumb): ' + mediaFound.thumbnail_display_urls.square);
                            let imageToPush = {
                                "id": mediaFound["o:id"],
                                "image": mediaFound.thumbnail_display_urls.square,
                                "type": mediaFound["o:media_type"].split('/')[0]
                            };
                            this.relatedData.push(imageToPush);
                        }
                    }
                    if(mediaFound["o:media_type"] && mediaFound["o:media_type"].split('/')[0] === 'video') {
                        console.log('video gevonden');
                    }
                    if(mediaFound["@type"] === 'o-cnt:ContentAsText') {
                        // console.log('html gevonden');
                        if(mediaFound["dcterms:title"]) {
                            mediaFound["dcterms:title"].forEach((htmlTitle) => {
                                if(htmlTitle["@language"] && htmlTitle["@language"] === this.langId) {
                                    // console.log('html taal: ' + this.langId);
                                    this.objectData.description = mediaFound.data.html;
                                }
                            });
                        }
                    }
                });
            })
            .catch();
            // res.data.related.forEach((foundRelated) => {
            //     if(foundRelated.image !== ''){
            //         var relatedItem = {
            //             "id": foundRelated.id,
            //             "object_number": foundRelated.object_number,
            //             "type": foundRelated.type,
            //             "image": this.apiData.test.dams + foundRelated.media
            //         }
            //         this.relatedData.push(relatedItem);
            //     }
            // });
        })
        .catch();
    },
  beforeDestroy() {
    this.objectData.audio = null;
    delete this.objectData.audio;
  }
}
</script>

<style>
/* mobile */
/* scrollbalk */
body::-webkit-scrollbar {
  width: 1em;
}
body::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

body::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}

.item {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100%;
    height: fit-content;
    color: white;
    padding-bottom: 140px;
}
.main {
    /* background-color: white; */
    color: black;
    float: none;
    height: fit-content;
    width: 90%;
  margin-right: auto;
  margin-left: auto;
}
.description {
    float: none;
    width: 100%;
    /* padding-left: 4%; */
    padding-top: 10px;
    font-family: EtelkaLight;
    color: white;
    font-size: 1.2em;
    clear: left;
}
.media {
    width: 100%;
}
.reproduction {
    position: relative;
    width: 100%;
}
.reproduction-image {
    width: 100%;
    height: auto;
}

.reproduction-credit {
    position: absolute;
    bottom: 0;
    padding-top: 2px;
    width: 100%;
    height: 24px;
    text-align: center;
    color: white;
    /* background-color: #ffffff88; */
}
.container-media-sub {
  width: 90%;
  margin-right: auto;
  margin-left: auto;
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: column;
}
.container-audio {
  width: 100%;
  height: 70px;
    margin-bottom: 5px;
  /*background-color: aquamarine;*/
}
.container-related {
  width: 100%;
  margin-bottom: 5px;
  display: flex;
  gap: 5px;
}
.button-related {
    /*float: left;*/
    width: 20%;
    /*object-fit: cover;*/
    height: 60px;
}
.image-related {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.header {
    margin-top: 70px;
    width: 90%;
  margin-left: auto;
  margin-right: auto;
    color: white;
}
.header>kiosk-title {
  font-size: 1em;
}
.header>group-title {
  font-size: 1em;
}
.fields {
    /* float: left; */
    width: 100%;
    color: white;
}
.object-nr {
    font-family: EtelkaMedium;
    font-size: 1.2em;
    width: 100%;
  margin-top: 10px;
}
.object-title {
    font-family: EtelkaMedium;
    font-size: 1.4em;
    margin-top: 5px;
    width: 100%;
}
.object-date {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
}
.title-date {
    font-size: 1.2em;
  font-family: EtelkaMedium;
}
.text-date {
    margin-left: 10px;
    font-size: 1.1em;
  font-family: EtelkaLight;
}
.object-makers {
    width: 90%;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
}
.title-makers {
    font-size: 1.2em;
  font-family: EtelkaMedium;
}
.item-makers {
    margin-left: 10px;
    font-size: 1.1em;
  font-family: EtelkaLight;
}
.object-materials {
    margin-top: 30px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
}
.title-materials {
    font-size: 1.2em;
  font-family: EtelkaMedium;
}
.item-materials {
    margin-left: 10px;
    font-size: 1.1em;
  font-family: EtelkaLight;
}

.object-dimensions {
  margin-top: 30px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
.title-dimensions {
  font-size: 1.2em;
  font-family: EtelkaMedium;
}
.item-dimensions {
  margin-left: 10px;
  font-size: 1.1em;
  font-family: EtelkaLight;
}

.object-context {
    margin-top: 30px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
}
.title-context {
    font-size: 1.2em;
  font-family: EtelkaMedium;
}
.text-context {
    margin-left: 10px;
    font-size: 1.1em;
  font-family: EtelkaLight;
}
.object-creditline {
    margin-top: 30px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    font-size: 1.1em;
  font-family: EtelkaLight;
}
@media only screen and (min-width: 768px) {
    .nav {
        height: 0;
    }
    .item {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: fit-content;
        min-height: 100%;
        color: white;
        padding-bottom: 0;
    }
    .main {
        /* float: left; */
        position: absolute;
        top: 0;
        left: 0;
        background-color: white;
        color: black;
        min-height: 100%;
        height: fit-content;
        width: 70%;
    }
    .description {
        float: left;
        width: 45%;
        padding-left: 4%;
        padding-top: 5%;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        font-size: 1.5em;
        color: black;
    }
    .media {
        float: right;
        width: 45%;
        padding-right: 4%;
        padding-top: 5%;
    }
    .reproduction {
        position: relative;
        width: 100%;
    }
    .reproduction-image {
        /* position: absolute; */
        object-fit: contain;
        width: 100%;
        height: 600px;
    }

    .reproduction-credit {
        position: absolute;
        bottom: 0;
        padding-top: 2px;
        width: 100%;
        height: 24px;
        text-align: center;
        color: black;
        background-color: #ffffff88;
    }
    .container-media-sub {
      width: 100%;
      position: relative;
    }
    .container-related {
        width: 100%;
    }
    .button-related {
        float: left;
        width: 20%;
        object-fit: cover;
        height: 90px;
    }
    .header {
        margin-top: 0;
        padding-top: 5%;
        float: right;
        width: 30%;
        color: white;
        font-family: Avenir, Helvetica, Arial, sans-serif;
    }
    .header hr {
        visibility: visible;
    }
    .object-nr {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        font-size: 1.4em;
        margin-left: 30px;
    }
    .object-title {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        font-size: 1.8em;
        margin-top: 5px;
        margin-left: 30px;
    }
    .fields {
        /* float: left; */
        position: absolute;
        top: 30%;
        height: 70%;
        right: 0;
        width: 30%;
        color: white;
        font-family: Avenir, Helvetica, Arial, sans-serif;
    }
    .object-date {
        margin-left: 30px;
    }
    .title-date {
        font-size: 1.6em;
    }
    .text-date {
        margin-left: 10px;
        font-size: 1.4em;
    }
    .object-makers {
        margin-top: 30px;
        margin-left: 30px;
    }
    .title-makers {
        font-size: 1.6em;
    }
    .item-makers {
        margin-left: 10px;
        font-size: 1.4em;
    }
    .object-materials {
        margin-top: 30px;
        margin-left: 30px;
    }
    .title-materials {
        font-size: 1.6em;
    }
    .item-materials {
        margin-left: 10px;
        font-size: 1.4em;
    }
    .object-context {
        margin-top: 30px;
        margin-left: 30px;
    }
    .title-context {
        font-size: 1.6em;
    }
    .text-context {
        margin-left: 10px;
        font-size: 1.4em;
    }
    .object-creditline {
        margin-top: 30px;
        margin-left: 30px;
        font-size: 1.4em;
    }
}
</style>
